import ProductsService from '@/services/products'

export default {
	namespaced: true,
	state: {
	},

	getters: {
		async getItems({ commit, state, getters, dispatch }) {
			try {
				let response = await ProductsService.getItems()
				return response
			} catch (e) {
				console.log(e)
			}
		},
	},
	
	actions: {
		async getProducts({ commit, state, getters, dispatch }, page) {
			try {
				let response = await ProductsService.getProducts(page)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getUserItems({ commit, state, getters, dispatch }, page) {
			try {
				let response = await ProductsService.getUserItems(page)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getProductJasa({ commit, state, getters, dispatch }) {
			try {
				let opts = {
					'interfaces': ['pos'],
					'type': ['MANAGED_TIME'],
					'product_category_id': 'ALL'
				}
				let response = await ProductsService.getProductJasa(opts)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getProductJasaHargaJual({ commit, state, getters, dispatch }, hargaJual) {
			try {
				let opts = {
					'interfaces': ['pos'],
					'type': ['MANAGED_TIME'],
					'harga_jual': hargaJual,
					'product_category_id': 'ALL'
				}
				let response = await ProductsService.getProductJasa(opts)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getProductByName({commit, state, getters, dispatch}, filter) {
			try {
				let response = await ProductsService.getProductByName(filter)
				return response
			}catch(e){
				console.log(e)
			}
		},
		async createProducts({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await ProductsService.createProducts({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async bulkProduk({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await ProductsService.bulkProduk({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async updateProducts({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await ProductsService.updateProducts(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async deleteProducts({ commit, state, getters, dispatch }, id) {
			let response
			try {
				response = await ProductsService.deleteProducts(id);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async getScheduleByProductId({ commit, state, getters, dispatch }, id) {
			let response
			try {
				response = await ProductsService.getScheduleByProductId(id);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async getProductById({ commit, state, getters, dispatch }, id) {
			let response
			try {
				response = await ProductsService.getProductById(id);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async uploadImage({commit, state, getters, dispatch}, payload) {
			try{
				const response = await ProductsService.uploadImage(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async removeImage({commit, state, getters, dispatch}, payload) {
			try{
				const response = await ProductsService.removeImage(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async updateItem({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await ProductsService.updateItems(payload.id, {...payload})
				return response
			} catch (e) {
				console.log(e)
			}
		},
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
